module.exports = {
      id: "grid-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#grid",
      toString: function () {
        return this.url;
      }
    }